module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать транзакцию\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'client-transaction-details',
        params: {
          transaction_id: _vm.transaction.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям транзакции")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.transaction.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteTransaction.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить транзакцию")]) : _vm._e()]), _vm._v(" "), _c('transaction-edit-form', {
    attrs: {
      "transaction": _vm.transaction
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcf54a16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/transaction/TransactionEdit.vue
// module id = 729
// module chunks = 0